export default "__VITE_ASSET__joxPPAX0__"